module.exports = __webpack_public_path__ + "18fc15b5080c130853c6f2bd27d1d9b4.jpg";